import type { ReactNode } from "react";

import styles from "./AssistantText.module.css";

function inline(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  const pattern = /\*\*(.+?)\*\*/g;
  let cursor = 0;
  let match = pattern.exec(text);
  while (match) {
    if (match.index > cursor) nodes.push(text.slice(cursor, match.index).replaceAll("**", ""));
    nodes.push(<strong key={`${match.index}-${match[1]}`}>{match[1]}</strong>);
    cursor = match.index + match[0].length;
    match = pattern.exec(text);
  }
  if (cursor < text.length) nodes.push(text.slice(cursor).replaceAll("**", ""));
  return nodes;
}

export function AssistantText({ text, className = "" }: { text: string; className?: string }) {
  const lines = text.replace(/\r\n/g, "\n").split("\n");
  return (
    <div className={`${styles.root} ${className}`.trim()}>
      {lines.map((rawLine, index) => {
        const line = rawLine.trim();
        if (!line) return <span className={styles.space} key={`space-${index}`} />;
        const heading = line.match(/^#{1,4}\s+(.+)$/);
        if (heading) return <p className={styles.heading} key={`heading-${index}`}>{inline(heading[1])}</p>;
        const bullet = line.match(/^[-*]\s+(.+)$/);
        if (bullet) return <p className={styles.item} key={`bullet-${index}`}><span>•</span><span>{inline(bullet[1])}</span></p>;
        const numbered = line.match(/^(\d+)[.、]\s*(.+)$/);
        if (numbered) return <p className={styles.item} key={`number-${index}`}><span>{numbered[1]}.</span><span>{inline(numbered[2])}</span></p>;
        return <p key={`line-${index}`}>{inline(line)}</p>;
      })}
    </div>
  );
}
